import { InternalAxiosRequestConfig } from "axios";
import { authRequestInterceptor } from "./authRequestInterceptor";
import { baseUrlWPRequestInterceptor } from "./baseUrlWPRequestInterceptor";
import { guestAbortRequestInterceptor } from "./guestAbortRequestInterceptor";
import { logInterReq } from "./logInterReq";
import { spTraceInterReq } from "./spTraceInterReq";
export const comboInterceptorReq = async (request: InternalAxiosRequestConfig) => {
  request = guestAbortRequestInterceptor(request);
  request = baseUrlWPRequestInterceptor(request);
  request = spTraceInterReq(request);
  request = logInterReq(request);
  request = await authRequestInterceptor(request);
  return request;
};
